// Small stuff
export default () => {
	const banners = document.querySelectorAll('.marquee .marquee-inner');
	for(let banner of banners) {
		const speed = banner.getAttribute('data-speed');
		setSpeed(banner, speed);
		window.addEventListener('resize', ()=>{
			setSpeed(banner, speed);
		})
	}
} 

const setSpeed = (el, speed) => {
	let mobile = window.matchMedia('(max-width: 767px)');
	const speed_m = speed * 1.3333;
	if (mobile) {
		el.style.animationDuration = speed_m + 's';
	} else {
		el.style.animationDuration = speed + 's';
	}
}